<template>
  <div>
    <h2>Admin email notifications settings</h2>
        <v-expansion-panel focusable>
          <v-expansion-panel-content v-for="(item, notificationSettingsIndex) in notificationSettings" :key="`settingType${notificationSettingsIndex}`">
            <div slot="header">{{item.notificationKey}}</div>
            <v-card>
              <v-card-text>
                <v-switch
                  :label="item.isEnabled? 'Enabled': 'Disabled'"
                  v-model="item.isEnabled"
                ></v-switch>

                <v-layout row>
                  <v-flex xs5>
                    <v-select
                      single-line
                      :items="adminNotificationsTemplatesList"
                      v-model="item.emailTemplateKey"
                      label="Select email template"
                      item-text="templateKey"
                      item-value="templateKey"
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout row v-for="(email, receiverMailBoxesIndex) in item.receiverMailBoxes" :key="`receiverEmail${receiverMailBoxesIndex}`">
                  <v-flex xs5>
                    <content-field
                      type="email"
                      label="Receiver email"
                      :error="$v.notificationSettings.$each[notificationSettingsIndex].receiverMailBoxes.$each[receiverMailBoxesIndex]"
                      @blur="$v.notificationSettings.$each[notificationSettingsIndex].receiverMailBoxes.$each[receiverMailBoxesIndex].$touch()"
                      v-model="item.receiverMailBoxes[receiverMailBoxesIndex]"
                      required
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-btn xs5 @click="deleteEmailInputLine(item, receiverMailBoxesIndex)">Delete email</v-btn>
                  </v-flex>
                </v-layout>
                <v-btn @click="addEmailInputLine(item)">Add new email</v-btn>
                <v-btn
                  color="success"
                  @click="submitChanges(item)"
                  :disabled="$v.notificationSettings.$each[notificationSettingsIndex].$invalid"
                >
                  submit
                </v-btn>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { clone, isEmpty } from 'ramda'
import mixins from '@/utils/mixins'
import { email } from 'vuelidate/lib/validators'

export default {
  name: 'admin-notifications-settings',
  mixins: [mixins.emailTemplates],
  data () {
    return {
      notificationSettings: null,
      notificationSettingForValidation: null
    }
  },
  computed: {
    ...mapGetters(['getAdminSettings'])
  },
  watch: {
    getAdminSettings: {
      handler (newVal) {
        if (!isEmpty(newVal)) {
          this.notificationSettings = clone(newVal)
        }
      },
      immediate: true
    }
  },
  validations: {
    notificationSettings: {
      $each: {
        receiverMailBoxes: {
          $each: {
            email
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['fetchAdminSettings', 'updateAdminSettings']),
    async requestData () {
      await this.fetchAdminSettings()
    },
    submitChanges (item) {
      this.updateAdminSettings(item)
    },
    addEmailInputLine (item) {
      let emailListLength = item.receiverMailBoxes.length
      item.receiverMailBoxes=[...item.receiverMailBoxes, '']
    },
    deleteEmailInputLine (item, index) {
      const arr1 = item.receiverMailBoxes.slice(index+1) // copy from this index to the end
      const arr2 = item.receiverMailBoxes.slice(0, index) // copy from beginning to this index
      const arr3 = arr1.concat(arr2)
      item.receiverMailBoxes=[...arr3]
    }
  },
  created () {
    this.requestData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/EmailNotificationsSettings/AdminNotificationsSettings/index.vue